/* eslint-disable jsx-a11y/label-has-associated-control */
import { useCallback, useEffect, useState } from "react";
import { Input, Form, Button, Upload } from "antd";
import { useNavigate } from "react-router-dom";
import { Warning2, DocumentUpload } from "iconsax-react";

import {
  ref as sRef,
  uploadBytes,
  getDownloadURL,
  getStorage,
} from "firebase/storage";
import Swal from "sweetalert2";

import MobileLayout from "../../../components/MobileLayout";
import { useModulos } from "../../../hooks/module";
import { useProfiles } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";

import { Main, Box, FooterConfig } from "./styles";

function ModuleClass() {
  const { getAll } = useProfiles();
  const navigate = useNavigate();

  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  const { createModulos } = useModulos();

  const [tumblr, setTumblr] = useState("");

  interface FormProps {
    title: string;
    description: string;
  }

  const handleAddModule = useCallback(
    async ({ title, description }: FormProps) => {
      console.log(title);
      try {
        if (createModulos) {
          await createModulos({
            title,
            tumblr,
            description,
          });
        } else {
          console.log("nn deu bom");
        }
      } catch (err) {
        console.log(err);
      }
    },
    [createModulos, tumblr]
  );

  const onPreview = async (file: any) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  function geraStringAleatoria(tamanho: number) {
    let stringAleatoria = "";
    const caracteres =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < tamanho; i += 1) {
      stringAleatoria += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length)
      );
    }
    return stringAleatoria;
  }

  const customUpload = async ({ file }: any) => {
    const storage = getStorage();
    const metadata = {
      contentType: "image/jpeg/",
    };

    const nick = geraStringAleatoria(16);
    if (!user?.uid) return;
    const fileName = user.uid;
    const imgFile = sRef(storage, `tumblr/${fileName + nick}.png`);
    Swal.fire({
      title: "Realizando envio...",
      showConfirmButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: async () => {
        Swal.showLoading();
        try {
          await uploadBytes(imgFile, file, metadata);
          console.log("enviou");
          const downloadUrl = await getDownloadURL(imgFile);
          setTumblr(downloadUrl);
          Swal.close();
          Swal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
          });
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Aconteceu algum erro inesperado.\nTente novamente.",
          });
          console.log(e);
        }
      },
    });
  };

  return (
    <MobileLayout headerTitle="Novo Módulo" headerType="private">
      <Main>
        <Box className="box">
          <strong>
            <h1>Dados do Módulo</h1>
          </strong>
          <Form onFinish={handleAddModule}>
            <label htmlFor="title">Título do Módulo</label>
            <Form.Item
              name="title"
              rules={[
                { required: true, message: "O nome do módulo é obrigatório!" },
              ]}
            >
              <Input name="title" placeholder="Insira o nome do Módulo" />
            </Form.Item>
            <label htmlFor="description">Descrição curta do Módulo</label>
            <Form.Item
              name="description"
              rules={[
                { required: true, message: "A descrição é obrigatória!" },
              ]}
            >
              <Input
                name="description"
                placeholder="Insira a descrição do Módulo"
                showCount
                maxLength={200}
              />
            </Form.Item>

            <label htmlFor="tumblr">Capa para o Módulo</label>
            <br />
            <label htmlFor="tumblr">
              formatos aceitos: (.png, .jpg, .jpeg)
            </label>
            <Upload
              accept=".png, .jpg, .jpeg"
              name="tumblr"
              customRequest={customUpload}
              onPreview={onPreview}
              style={{ width: "100%", marginTop: "20px" }}
              listType="picture"
              maxCount={1}
            >
              <Button
                htmlType="button"
                style={{
                  width: "100%",
                  textAlign: "start",
                  height: "5.6rem",
                  borderRadius: "0.8rem",
                }}
                icon={<DocumentUpload size={18} />}
              >
                Anexar imagem
              </Button>
            </Upload>

            <FooterConfig>
              <p>
                <Warning2 size={48} />
                Atenção! <br />É necessário preecher todos os dados.
              </p>
              <Button htmlType="submit">Salvar cadastro</Button>
            </FooterConfig>
          </Form>
        </Box>
      </Main>
    </MobileLayout>
  );
}

export default ModuleClass;
